import { set } from 'lodash/fp';

import { CHANNELS as CHANNELS_TYPES } from '../../constants/channels';

export const CHANNELS = 'CHANNELS';
export const CHANNELS_SET_DATA = 'CHANNELS_SET_DATA';
export const CHANNELS_SET_LOADING = 'CHANNELS_SET_LOADING';
export const CHANNELS_SET_CONFIGURATION = 'CHANNELS_SET_CONFIGURATION';

const initialState = {
  channels: [],
  requiredConfigurations: {
    [CHANNELS_TYPES.TIKTOK]: null,
    [CHANNELS_TYPES.MIRAKL]: null,
  },
  data: {
    [CHANNELS_TYPES.TIKTOK]: {
      brands: [],
      designers: [],
      warehouses: [],
      brandIdMapping: {},
    },
    [CHANNELS_TYPES.MIRAKL]: {
      returnCodes: {},
    },
  },
  loading: {
    listWarehouses: true,
    listBrands: true,
    listDesigners: true,
    listReturnCodes: true,
    postWarehouse: false,
    postBrandIdMapping: false,
    postReturnCode: false,
  },
};

const channelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANNELS:
      return set('channels', action.payload, state);

    case CHANNELS_SET_DATA: {
      const { integrationType, data } = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          [integrationType]: {
            ...state.data[integrationType],
            ...data,
          },
        },
      };
    }

    case CHANNELS_SET_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload.loading,
        },
      };

    case CHANNELS_SET_CONFIGURATION: {
      const { integrationType, data } = action.payload;
      return {
        ...state,
        requiredConfigurations: {
          ...state.requiredConfigurations,
          [integrationType]: {
            ...state.requiredConfigurations[integrationType],
            ...data,
          },
        },
      };
    }

    default:
      break;
  }

  return state;
};

export default channelsReducer;
